export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_en_US_saptrc.9bc9aa064bc6ecc9.json"